<script>
    import dressing from "@intellectability/platform-common";
    import {Button, Report, Modal} from "@intellectability/platform-common/sv";
    import {ModalBody, ModalFooter} from "@sveltestrap/sveltestrap";

    import {fade} from "svelte/transition";

    /** @import { Snippet } from 'svelte' */

    /** @typedef {Object} props
     *  @property {function} [onopen]
     *  @property {function} [onclose]
     *  @property {Snippet<[function, string]>} [modalOpenButton]
     *  @property {number} cardID
     */

    /** @type {props} */
    let {
        cardID,
        disabled = false,
        modalOpenButton = null,
        onclose = null, // callback
        onopen = null, // callback function
        reportTitle = "Report"
    } = $props();

    let loading = $state(false);
    let modalOpen = $state(false);

    /** @type {any} */
    let reportData = $state([]);

    let pagination = $state({
        show: true,
        page: 1,
        limit: 10,
        recordsFiltered: null,
        recordsTotal: null,
        pageLengthMenu: [25, 50, 100, 500]
    });

    let columns = $derived.by(function () {

        if (Array.isArray(reportData) && reportData.length > 0) {

            let column_names = Object.keys(reportData[0]);

            let column_definitions = column_names.map(name => {
                return {
                    name: name,
                    field: name,
                    sortable: true,
                    sort: "asc"
                };
            });

            return column_definitions;
        }
    });

    $effect(function () {
        if (modalOpen && cardID) {
            loading = true;

            // fetch report data
            const body = {
                card_id: cardID,
                context: "dashboard_user_click"
            };

            dressing.post(`/dashboard/cards/data`, body)
                .then(({data: res}) => {
                    const {success, data} = res;
                    if (success === true) {
                        const {value} = data;
                        if (Array.isArray(value) && value.length > 0) {
                            reportData = value;
                        }
                        typeof onopen === "function" && onopen(value);
                    }
                    loading = false;
                })
                .catch(error => {
                        console.log(error);
                        loading = false;
                    }
                );

        }
    });

    function toggle_modal() {
        modalOpen = !modalOpen;

        if (modalOpen) {
            typeof onopen === "function" && onopen();
        }
    }
</script>

{#if modalOpenButton}
    {@render modalOpenButton?.(toggle_modal, "Run report", disabled)}
{:else}
    <Button class="fs-6" onclick={toggle_modal} {disabled}>
        Run selected report
    </Button>
{/if}

<Modal bind:showModal={modalOpen} title={reportTitle} scrollable={true} size="fullscreen">
    <ModalBody>
        {#if !loading}
            <Report data={reportData}/>
        {:else}
            <div in:fade|global class="position-relative">
                <div class="loading-element">
                    <h3>Loading report</h3>
                </div>
                <wa-skeleton class="border border-2" effect="sheen"></wa-skeleton>
                <wa-skeleton class="border border-2" effect="sheen"></wa-skeleton>
                <wa-skeleton class="border border-2" effect="sheen"></wa-skeleton>
                <wa-skeleton class="border border-2" effect="sheen"></wa-skeleton>
                <wa-skeleton class="border border-2" effect="sheen"></wa-skeleton>
                <wa-skeleton class="border border-2" effect="sheen"></wa-skeleton>
                <wa-skeleton class="border border-2" effect="sheen"></wa-skeleton>
                <wa-skeleton class="border border-2" effect="sheen"></wa-skeleton>
                <wa-skeleton class="border border-2" effect="sheen"></wa-skeleton>
                <wa-skeleton class="border border-2" effect="sheen"></wa-skeleton>
                <wa-skeleton class="border border-2" effect="sheen"></wa-skeleton>
                <wa-skeleton class="border border-2" effect="sheen"></wa-skeleton>
                <wa-skeleton class="border border-2" effect="sheen"></wa-skeleton>
            </div>
        {/if}
    </ModalBody>
    <ModalFooter class="justify-content-start">
        <button class="btn btn-primary rounded-pill btn-lg fs-6"
                onclick={toggle_modal}>
            Close
        </button>
    </ModalFooter>
</Modal>

<style>
    .loading-element {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        padding: 20px;
        border-radius: 25px;
        backdrop-filter: blur(2px);
        z-index: 2;
    }

    wa-skeleton {
        overflow: hidden;
        height: 25px;
        width: 100%;
        margin-bottom: 3px;
        --color: var(--hrst-secondary-50);
        --sheen-color: var(--hrst-warning-100);
        --border-radius: 0;
    }
</style>